export const UPDATE_CANDIDATE_STATUS = 'UPDATE_CANDIDATE_STATUS';
export const SET_CANDIDATE_STATUS = 'SET_CANDIDATE_STATUS';
export const GET_PROFILE_DETAILS = 'GET_PROFILE_DETAILS';
export const SET_PROFILE_DETAILS = 'SET_PROFILE_DETAILS';
export const UPDATE_CANDIDATE_PROFILE_IMAGE = 'UPDATE_CANDIDATE_PROFILE_IMAGE';
export const SET_CANDIDATE_PROFILE_IMAGE="SET_CANDIDATE_PROFILE_IMAGE";

export const GET_TALENTPOOL = 'GET_TALENTPOOL';
export const SET_TALENTPOOL = 'SET_TALENTPOOL';
export const VIEW_CANDIDATE = 'VIEW_CANDIDATE';
export const GET_TALENTPOOL_RECRUITER = 'GET_TALENTPOOL_RECRUITER';
export const SET_CURRENT_ROLE = 'SET_CURRENT_ROLE';
export const IMPORT_CANDIDATE_RECRUITER = 'IMPORT_CANDIDATE_RECRUITER';
export const REMOVE_CANDIDATE_RECRUITER = 'REMOVE_CANDIDATE_RECRUITER';
export const VIEW_CANDIDATE_RECRUITER = 'VIEW_CANDIDATE_RECRUITER';
export const CLEAR_TALENT_POOL = 'CLEAR_TALENT_POOL';
export const SET_PERMITTED_CONTACT = 'SET_PERMITTED_CONTACT';
export const SET_CANDIDATE_EDIT_STATUS = 'SET_CANDIDATE_EDIT_STATUS';
export const SET_CANDIDATE_CARD_IMAGE = 'SET_CANDIDATE_CARD_IMAGE';
export const SET_CANDIDATE_PROFILE_EDIT='SET_CANDIDATE_PROFILE_EDIT';

export const UPDATE_CANDIDATE_PUBLISHED = 'UPDATE_CANDIDATE_PUBLISHED';

export const GET_GROUP_TALENTPOOL = 'GET_GROUP_TALENTPOOL';
export const SET_GROUP_TALENTPOOL = 'SET_GROUP_TALENTPOOL';
export const UPDATE_CANDIDATE_PRIORITY = 'UPDATE_CANDIDATE_PRIORITY';
export const SET_JOBTITLE = 'SET_JOBTITLE';
export const SET_JOBLIST = 'SET_JOBLIST';


export const GET_CLIENT_DETAILS = 'GET_CLIENT_DETAILS';
export const SET_CLIENT_DETAILS = 'SET_CLIENT_DETAILS';
export const UPDATE_PROFILE_IMAGE = 'UPDATE_PROFILE_IMAGE';
export const GET_PROFILE_IMAGE = 'GET_PROFILE_IMAGE';
export const GET_INTERVIEWLIST_COUNT = 'GET_INTERVIEWLIST_COUNT';
export const SET_INTERVIEWLIST_COUNT = 'SET_INTERVIEWLIST_COUNT';

export const COGNITO_LOGOUT = 'COGNITO_LOGOUT';

export const SET_UPLOAD_BUTTON = 'SET_UPLOAD_BUTTON';
export const SET_PAGEDATA_LOSS = 'SET_PAGEDATA_LOSS';

export const SET_PROGRESS_NOTIFICATION= 'SET_PROGRESS_NOTIFICATION';



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js